import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {message, Spin} from "antd";
import {useAppDispatch} from "../store/hooks";
import {
  updateToken,
  updateUserInfo,
} from "../features/user/userSlice";
import {
  setAccessTokenSession,
  setRefreshTokenSession,
} from "../utility/common/session-store";
import {useAuth} from "../utility/AuthContext";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const OAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {login} = useAuth();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const loginCode = searchParams.get("login_code");

    if (!loginCode) {
      message.error("Login code missing");
      navigate("/");
      return;
    }

    const exchangeToken = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}auth/oauth/exchange`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({login_code: loginCode}),
        });

        const resJson = await response.json();

        if (resJson.code === 0 && resJson.data) {
          const data = resJson.data;

          // 1. 更新 Session
          setAccessTokenSession(data.token);
          setRefreshTokenSession(data.refresh_token);

          // 2. 更新 Redux Store
          // 注意：這裡的欄位名稱要跟後端回傳的 JSON 結構對應
          dispatch(updateUserInfo(data.user));
          dispatch(
            updateToken({
              access_token: data.token,
            })
          );

          // 3. 更新 Context
          login(data.token, data.refresh_token);

          console.log("Login Successful:", data);
          message.success("Login Successful");

          // 4. 判斷跳轉邏輯
          if (data.user.is_provider === true) {
            navigate("/installation");
          } else {
            navigate("/"); // 或跳轉到 dashboard
          }

        } else {
          console.error("Exchange failed:", resJson);
          message.error(resJson.msg || "Login Exchange Failed");
          navigate("/");
        }
      } catch (error) {
        console.error("Exchange error:", error);
        message.error("Login Error");
        navigate("/");
      } finally {
        setProcessing(false);
      }
    };

    // 執行換證
    exchangeToken();

  }, []);

  if (processing) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <Spin size="large" tip="Logging in..."/>
      </div>
    );
  }

  return null;
};

export default OAuthCallback;